import * as React from "react";
import "./styles.scss";

interface IProps {
    size?: string;
    buttonText: string;
    isDisabled?: boolean;
    onClick?: () => void;
    bgColor?: string;
    textColor?: string;
    icon?: string;
    borderColor?: string;
}

export const RoundedButton = (props: IProps) => {
    const buttonStyle = {
        display: "flex",
        justifyContent: "center",
        fontSize: 12,
        backgroundColor: !props.isDisabled ? props.bgColor ? props.bgColor : "#F58220" : "#898989",
        boxShadow: "0px 3px 6px #00000029",
        borderRadius: 22,
        border: props.borderColor ? `1px solid ${props.borderColor}` : "",
        color: !props.isDisabled ? props.textColor ? props.textColor : "#FFFFFF" : "#C7C7C7",
        width: props.size === "large" ? "calc(100vw - 30%)" : "calc(100vw - 60%)",
        paddingTop: 8,
        paddingBottom: 8,
        maxWidth: 300,
    };
    return (
        <div className={`button ${props.isDisabled ? " disabled" : ""}`} style={buttonStyle}
             onClick={() => props.onClick ? props.onClick() : undefined}>
            {props.icon && <img src={props.icon} alt="icon" className="mr-8" />}
            {props.buttonText}
        </div>
    );
};

export default RoundedButton;
